import React from 'react';
import { connect, ResolveThunks } from 'react-redux';

import { withoutZeroEntries } from '@paragon/client-tools';
import { getLayoutModelsWithPendingChanges, getQuantityMap } from '@paragon/layout-models';
import { closeCurrentPopup, Dialog } from '@paragon/popup-state';

import { QuantitiesDialogSubmitAction } from '../../store/actions/dialogActions';
import { continueAfterQuantitiesDialogSubmission } from '../../store/actions/download';
import {
  getScopedComponentDesignQuantities,
  getScopeProjectGuids,
  ProjectActionScope,
} from '../../store/projectActionScope';
import { RootState } from '../../store/slices';
import { ChooseQuantities, QuantityOption } from './ChooseQuantities';

export interface ChooseQuantitiesDialogProps {
  readonly quantitiesDialogSubmitAction: QuantitiesDialogSubmitAction;
  readonly scope: ProjectActionScope;
}

type Props = StateProps & DispatchProps & ChooseQuantitiesDialogProps;

interface State {
  readonly quantityOption: QuantityOption;
  readonly quantities: { [guid: string]: number };
}

class ChooseQuantitiesDialog extends React.Component<Props, State> {
  state: State = {
    quantityOption: QuantityOption.Complete,
    quantities: getScopedComponentDesignQuantities(this.props.scope, this.props.quantityMap, 'fullQuantity'),
  };

  onQuantityChange = (quantityOption: QuantityOption, quantities: { [guid: string]: number }) => {
    this.setState({ quantityOption, quantities });
  };

  onSubmit = () => {
    this.props.continueAfterQuantitiesDialogSubmission(
      this.props.quantitiesDialogSubmitAction,
      withoutZeroEntries(this.state.quantities),
      this.props.groupName,
    );
    this.props.closeCurrentPopup();
  };

  render() {
    return (
      <Dialog title="How many of each component design?" onCancel="close" onSubmit={this.onSubmit}>
        <ChooseQuantities
          scope={this.props.scope}
          quantityOption={this.state.quantityOption}
          quantities={this.state.quantities}
          onQuantityChange={this.onQuantityChange}
        />
      </Dialog>
    );
  }
}

type StateProps = ReturnType<typeof mapStateToProps>;

function mapStateToProps(state: RootState, ownProps: ChooseQuantitiesDialogProps) {
  const layoutModelsWithPendingChanges = getLayoutModelsWithPendingChanges(state);

  return {
    quantityMap: getQuantityMap(state),
    groupName: getScopeProjectGuids(ownProps.scope)
      .map((projectGuid) => layoutModelsWithPendingChanges[projectGuid].name)
      .join(', '),
  };
}

type DispatchProps = ResolveThunks<typeof actionCreators>;
const actionCreators = {
  closeCurrentPopup,
  continueAfterQuantitiesDialogSubmission,
};

export default connect(mapStateToProps, actionCreators)(ChooseQuantitiesDialog);
